function cov_1w5oadkl5a() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/DateAdd.tsx";
  var hash = "868e2ee25aea3b5f3648051bad428642627f0827";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/DateAdd.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 48
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "868e2ee25aea3b5f3648051bad428642627f0827"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1w5oadkl5a = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1w5oadkl5a();
var Icon = (cov_1w5oadkl5a().s[0]++, {
  name: 'date-add',
  svg: "<path d=\"M12 12.25C12.6904 12.25 13.25 12.8096 13.25 13.5V14H14C14.6904 14 15.25 14.5596 15.25 15.25C15.25 15.9404 14.6904 16.5 14 16.5H13.25V17C13.25 17.6904 12.6904 18.25 12 18.25C11.3096 18.25 10.75 17.6904 10.75 17V16.5H10C9.30964 16.5 8.75 15.9404 8.75 15.25C8.75 14.5596 9.30964 14 10 14H10.75V13.5C10.75 12.8096 11.3096 12.25 12 12.25Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.25 3C8.25 2.30964 7.69036 1.75 7 1.75C6.30964 1.75 5.75 2.30964 5.75 3V4H5C3.34315 4 2 5.34315 2 7V19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V7C22 5.34315 20.6569 4 19 4H18.25V3C18.25 2.30964 17.6904 1.75 17 1.75C16.3096 1.75 15.75 2.30964 15.75 3V4H8.25V3ZM5.75 6.5V7C5.75 7.69036 6.30964 8.25 7 8.25C7.69036 8.25 8.25 7.69036 8.25 7V6.5H15.75V7C15.75 7.69036 16.3096 8.25 17 8.25C17.6904 8.25 18.25 7.69036 18.25 7V6.5H19C19.2761 6.5 19.5 6.72386 19.5 7V8.75H4.5V7C4.5 6.72386 4.72386 6.5 5 6.5H5.75ZM4.5 19V11.25H19.5V19C19.5 19.2761 19.2761 19.5 19 19.5H5C4.72386 19.5 4.5 19.2761 4.5 19Z\" fill=\"currentColor\"/>"
});
export default Icon;